import { BaseService } from './base-service';
export class ReportsService {
    static exportExcelClassroom(classroomId) {
        let dateString = (new Date()).toISOString().replace(/[:\.]/g, '');
        let filename = "classroom_" + classroomId + "_" + dateString + ".xlsx";
        BaseService.downloadFile(`reports/export-excel/classroom/${classroomId}`, filename, null);
    }
}
